import React from "react";

import { setBackUrl, userSignOutSuccess } from "../../appRedux/actions/Actions";
import { LoginOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { clearUser } from "../../appRedux/actions/Actions";
import {
   isCarlsbergUser,
   isBP2CloudOrCloudQA,
   isCpAdmin,
   isActivePublicUser,
   mobileStartActionByUrl,
   mobileStartFlutterActionByUrl,
} from "@util/Scripts";

import IntlMessages from "@util/IntlMessages";
import { Link } from "react-router-dom";
import { getFile } from "../../services/restAPI/RestApi";
import { setIsNavVisible } from "../../appRedux/actions/Setting";
import SidebarIcon from "./SidebarIcon";
import projectConfig from "@projectConfig";
import {
   Icon_Cases,
   Icon_ContentCopy,
   Icon_LogOut,
   Icon_Messages,
   Icon_Planner,
   Icon_Table,
   Icon_UserSettings,
   Icon_ViewModules,
} from "../../components/BP2Components/Icons/icons";
import { Menu } from "../../components/BP2Components";
import { logoutUser } from "../../services/api/Api";
import { getOS } from "../../util/Scripts";

const { Item } = Menu;
// TODO: Add it to backend eventually
export const getIcon = (board) => {
   switch (board.name) {
      case "sidebar.pricing":
         return <i className="icon icon-pricing-table" />;
      case "sidebar.notes":
         return <i className="icon icon-copy" />;
      case "sidebar.messages":
         return <Icon_Messages fill="none" stroke={"var(--nav-icon)"} className="icon" />;
      case "sidebar.cases":
         return <Icon_Cases fill="none" stroke={"var(--nav-icon)"} className="icon" />;
      case "sidebar.boards":
         return <Icon_ViewModules fill="var(--nav-icon)" className="icon" />;
      case "sidebar.boardsManager":
         return <Icon_Table fill={"var(--nav-icon)"} className="icon" />;
      case "sidebar.account":
         return <i className="icon icon-auth-screen" />;
      case "sidebar.UserSettings":
         return <Icon_UserSettings fill="var(--nav-icon)" className="icon" />;
      case "sidebar.logOut":
         return <Icon_LogOut fill="none" stroke={"var(--nav-icon)"} className="icon-logout" />;

      case "sidebar.planner":
         return <Icon_Planner fill="none" stroke={"var(--nav-icon)"} className="icon" />;

      // i don`t know why, but "public.login" and  "public.signup" are also added in navbarContent.
      // i moved it to to NavbarScripts.tsc file, to make NavbarContent cleaner, but still i dont get this logic :D
      // also i deleted it from here, becouse icons was not working here :v
      case "public.login":
         return projectConfig?.sidebar?.customPublicLoginIcons ? (
            <SidebarIcon src={board.iconLink} className="icon" />
         ) : (
            <LoginOutlined
               className="icon"
               style={{ fontSize: "20px", color: "var(--nav-icon)" }}
            />
         );
      default:
         return board?.boardIconId ? (
            <SidebarIcon
               src={`https://lh3.googleusercontent.com/u/0/d/${board?.boardIconId}`}
               className="icon"
            />
         ) : (
            <Icon_ContentCopy fill={"var(--nav-icon)"} className="icon" />
         );
   }
};

export const checkItemsByScenario = (allItems, authUser) => {
   // If any of the board should be hidden in specific scenario, this function will return false;
   return allItems.filter((item) => {
      switch (item.name) {
         case "sidebar.boardsManager":
            return (
               projectConfig?.sidebar?.visibleDefaultBoards?.includes(item.name) &&
               !isActivePublicUser()
            );
         case "sidebar.account":
            return (
               projectConfig?.sidebar?.visibleDefaultBoards?.includes(item.name) &&
               !isActivePublicUser()
            );
         case "sidebar.UserSettings":
            return (
               projectConfig?.sidebar?.visibleDefaultBoards?.includes(item.name) &&
               !isActivePublicUser() &&
               !isBP2CloudOrCloudQA()
            );
         case "sidebar.messages":
            return (
               projectConfig?.sidebar?.visibleDefaultBoards?.includes(item.name) &&
               !isActivePublicUser()
            );
         case "sidebar.logOut":
            return (
               projectConfig?.sidebar?.visibleDefaultBoards?.includes(item.name) &&
               !isActivePublicUser()
            );
         case "sidebar.planner":
            return projectConfig?.sidebar?.visibleDefaultBoards?.includes(item.name);

         default:
            return projectConfig?.sidebar?.visibleDefaultBoards?.includes(item.name);
      }
   });
};
export const handleSubMenuOptions = (
   boardName,
   boardsToSet,
   mailboxFolders,
   casesFolders,
   intl,
   companies,
   authUser,
   dispatch,
) => {
   switch (boardName) {
      case "sidebar.boards":
         if (Object.keys(boardsToSet).length === 0) boardsToSet = [];
         let boardsToShow;
         boardsToShow = boardsToSet
            ? boardsToSet.map((board) => {
                 if (!board.showInMainNav && !board.hidden) {
                    // opening process form boards works by reading fields from sheet. in sheet we got field "redirect: bool", if it`s true, we use URL
                    const redirectUrl = board?.sheets[0]?.url;
                    const redirect = board?.sheets[0]?.redirect;
                    const itemContent = (
                       <>
                          {board.iconLink && (
                             <SidebarIcon src={board.iconLink} className="icon-in-submenu" />
                          )}
                          <span style={{ marginLeft: "0.3rem" }}>
                             <IntlMessages id={board.name} />
                          </span>
                       </>
                    );
                    return (
                       <Item
                          key={board.id}
                          itemKey={board.id}
                          className={`sidebar__content__item ${
                             Number(window?.location.pathname.split("/")?.[2]) === board.id &&
                             "active-board"
                          }`}
                          title={board.name}
                          style={
                             board.name === "chat" && board.memberType !== "OWNER"
                                ? { display: "none" }
                                : {}
                          }
                       >
                          {redirectUrl && redirect ? (
                             <a
                                onClick={() => dispatch(setBackUrl(window.location.pathname))}
                                href={redirectUrl}
                                className="p2 sidebar__content__item_container"
                             >
                                {itemContent}
                             </a>
                          ) : (
                             <Link
                                to={`/boards/${board.id}/${board.firstSheetId}`}
                                className="p2 sidebar__content__item_container"
                             >
                                {itemContent}
                             </Link>
                          )}
                       </Item>
                    );
                 }
              })
            : [];
         if (
            projectConfig?.sidebar?.visibleDefaultBoards?.includes("sidebar.newsletter") ||
            (isCarlsbergUser(authUser) && isCpAdmin() === true)
         ) {
            boardsToShow.push(
               <Item key={"newsletter"} className="sidebar__content__item" title="Newsletter">
                  <Link to={`/boards/Newsletter`} className="p2">
                     Newsletter
                  </Link>
               </Item>,
            );
         }
         return boardsToShow;
      case "sidebar.account":
         return (
            <Item
               key="sidebar.account.UserSettings"
               className="sidebar__content__item"
               title={intl.formatMessage({ id: boardName })}
            >
               <Link to="/userAccount" className="p2">
                  <IntlMessages id={"sidebar.UserSettings"} />
               </Link>
            </Item>
         );
      case "sidebar.messages":
         let mailboxButtons;

         if (mailboxFolders) {
            mailboxButtons = mailboxFolders.map((folder) => {
               const isActive = window.location.pathname.includes(folder.handle);
               return (
                  <Item
                     key={`sidebar.messages${folder.id}`}
                     itemKey={`sidebar.messages${folder.id}`}
                     className={`sidebar__content__item ${isActive ? " selected" : ""}`}
                     title={folder.title}
                  >
                     <Link to={`${folder.handle}`} className="p2">
                        <div className="sidebar__content__item_container">
                           <i className={`icon icon-${folder.icon}`} />
                           {folder.title}
                        </div>
                     </Link>
                  </Item>
               );
            });
         } else {
            mailboxButtons = (
               <Item
                  key={`sidebar.messages`}
                  itemKey={`sidebar.messages`}
                  className="sidebar__content__item"
               >
                  <Link to={`/messages/addMailbox`} className="p2">
                     <div>
                        <span style={{ color: "var(--first)", marginLeft: "10px" }}>
                           {intl.formatMessage({ id: "mail.addMailbox" })}
                        </span>
                     </div>
                  </Link>
               </Item>
            );
         }

         return mailboxButtons;

      case "sidebar.cases":
         let casesButtons;
         if (casesFolders) {
            casesButtons = casesFolders.map((singleCase) => {
               const isActive = window.location.pathname.includes(singleCase.name);
               return (
                  <Item
                     key={`sidebar.messages${singleCase.id}`}
                     itemKey={`sidebar.messages${singleCase.id}`}
                     className={`sidebar__content__item ${isActive ? " selected" : ""}`}
                  >
                     <Link to={`${singleCase.handle}`} className="p2" title={singleCase.name}>
                        <div className="sidebar__content__item__title">
                           <div>{singleCase.icon}</div>
                           <div style={{ width: "max-content" }}>{singleCase.title}</div>
                        </div>
                     </Link>
                  </Item>
               );
            });
         }
         return casesButtons;
      default:
         break;
   }
};

export const handleItemClick = (option) => {
   const dispatch = useDispatch();

   switch (option.name) {
      case "sidebar.logOut":
         try {
            window.mobileApp.appLogout();
            mobileStartFlutterActionByUrl("appLogout", null);
         } catch (err) {}
         logoutUser();
         localStorage.removeItem("publicID");
         localStorage.removeItem("pocJWT");
         localStorage.removeItem("isPublicUserLogged");
         if (projectConfig?.publicUser) {
            localStorage.setItem("publicLogging", "1");
         }
         dispatch(clearUser());
         dispatch(userSignOutSuccess());
         break;

      case "sidebar.login":
         mobileStartActionByUrl(`/signin`);
         mobileStartFlutterActionByUrl("startActionByUrl", `/signin`);
         break;
      case "sidebar.signUp":
         mobileStartActionByUrl(`/signUp`);
         mobileStartFlutterActionByUrl("startActionByUrl", `/signin`);
      default:
         break;
   }
};

export const sortObjects = (objects) => {
   return objects.sort((a, b) => a.order - b.order);
};

export const updateUrlToNull = (objects, name) => {
   return objects.map((object) => {
      if (object.name === name) {
         return { ...object, url: null };
      }
      return object;
   });
};

export const sortByOrder = (items) => {
   const sortedItems = items.sort((item1, item2) => {
      return item1.order - item2.order;
   });
   return sortedItems;
};

export const sortByBoardOrder = (boardsToSort) => {
   let sortedBoards = [];
   if (boardsToSort) {
      sortedBoards = boardsToSort.sort((item1, item2) => {
         return item1.boardOrder - item2.boardOrder;
      });
   }
   return sortedBoards;
};

export const setInitialNavStatus = (dispatch) => {
   // In some scenarios we have to manipulate state of the navbar on the initial render
   // This is the place to do that

   // Przemek told me to hide default navbar open on mobile devices
   if (getOS() === "Android" || getOS() === "iOS") {
      dispatch(setIsNavVisible(false));
   } else {
      dispatch(setIsNavVisible(projectConfig?.sidebar?.isDefaultOpen ?? true));
   }
};

/**
 * Filters navigation options based on visibility settings.
 *
 * This function removes options from the list based on the visibility options provided.
 * It uses a mapping of visibility keys to option names that should be hidden when the corresponding visibility key is `false`.
 *
 * @param {Array<{optionTypes}>} options - The list of navigation options to filter.
 * @param {Record<string, boolean>} visibilityOptions - An object representing visibility settings (e.g., `{ isToDoVisible: false }`).
 * @returns {Array<{optionTypes}>} - The filtered list of navigation options.
 *
 * @example
 * const options = [
 *    { id: 1, name: 'sidebar.cases', order: 3, url: null },
 *    { id: 2, name: 'sidebar.planner', order: 4, url: '/planner' },
 *    { id: 3, name: 'sidebar.boardsManager', order: 5, url: '/boardsManagment' },
 * ];
 *
 * const visibilityOptions = {
 *    isToDoVisible: false,
 *    isPlanVisible: true,
 * };
 *
 * const result = hideNavigationOptions(options, visibilityOptions);
 * // Output: [{ id: 2, name: 'sidebar.planner', order: 4, url: '/planner' }, { id: 3, name: 'sidebar.boardsManager', order: 5, url: '/boardsManagment' }]
 */
export const hideNavigationOptions = (options, visibilityOptions) => {
   if (!options) return options;

   // here you can add other options you want to hide, alike existing one. (other example: isPlanVisible: ['sidebar.planner'])
   const visibilityMap = {
      isToDoVisible: ["sidebar.cases"],
   };

   const namesHidden = new Set(
      Object.entries(visibilityMap)
         .filter(([key]) => visibilityOptions?.[key] === false)
         .flatMap(([, names]) => names),
   );

   const visibleOptions = options.filter((opt) => !namesHidden.has(opt?.name));

   const normalizeOrder = (value) => {
      return Number.isFinite(value) ? value : 0;
   };

   const boardList = visibleOptions.map((opt, idx) => ({
      opt,
      sortOrder: normalizeOrder(opt?.boardOrder ?? opt?.order),
      idx,
   }));

   boardList.sort((a, b) => {
      if (a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder;
      return a.idx - b.idx;
   });

   return boardList.map(({ opt }) => opt);
};
